import { transformProduct } from "~/features/productDetails/transformers/ProductDataTransformer";
import type { ProductDataDTO } from "~/domains/product/types/ProductDataDTO";
import type { ProductData } from "~/domains/product/types/ProductData";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export interface FrequentlyBoughtTogetherResponseDTO {
  firstRelation?: ProductDataDTO[];
  secondRelation?: ProductDataDTO[];
}

export async function fetchFrequentlyBoughtTogetherProducts(
  code: string,
): Promise<{ first: ProductData[]; second: ProductData[] }> {
  const url = occUrl(`/p/${code}/frequentlyboughttogether`);

  const response = await occFetch(url);
  if (response.ok) {
    const data = (await response.json()) as FrequentlyBoughtTogetherResponseDTO;
    return {
      first: (data.firstRelation ?? []).map((product) => transformProduct(product as ProductDataDTO)),
      second: (data.secondRelation ?? []).map((product) => transformProduct(product as ProductDataDTO)),
    };
  }
  throw new Error("Error fetching data");
}
